module.exports = __webpack_public_path__ + "img/cms_datasets_create.bf4db478.jpg";